import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCapabilityGrid, setCapability, type CapabilityCell } from '../api/capabilities';
import { CAPABILITIES_KEY } from './useCan';

const GRID_KEY = [...CAPABILITIES_KEY, 'grid'] as const;

/** The grid for Settings → Messaging (administrators). */
export function useCapabilityGrid() {
  return useQuery({ queryKey: GRID_KEY, queryFn: getCapabilityGrid });
}

export function useSetCapability() {
  const queryClient = useQueryClient();
  return useMutation<CapabilityCell, Error, CapabilityCell>({
    mutationFn: setCapability,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CAPABILITIES_KEY }),
  });
}
